<template>
  <Layout style="height: 100%" class="main" v-if="showRouter">
    <Sider hide-trigger collapsible :width="256" :collapsed-width="64" v-model="collapsed" class="left-sider" :style="{overflow: 'hidden'}">
      <side-menu accordion ref="sideMenu" :active-name="$route.name" :collapsed="collapsed" @on-select="turnToPage" :menu-list="menuList">
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div v-show="!collapsed" class="logo-con">
          <img :src="lang === 'en' ? maxEnLogo : maxLogo" key="max-logo" />
        </div>
        <div v-show="collapsed" class="logo-con-min">
          <img :src="minLogo" key="min-logo" />
        </div>
      </side-menu>
    </Sider>
    <Layout>
      <Header class="header-con">
        <header-bar :collapsed="collapsed" @on-coll-change="handleCollapsedChange">
          <user :user-avator="userAvator"/>
          <switchSys/>
          <Language />

          <!-- <MessageCenter @on-lang-change="setLocal" style="margin-right: 10px;" :lang="local"/> -->
          <fullscreen v-model="isFullscreen" style="margin-right: 10px;"/>
          <!-- 三维看板按钮 -->
          <div v-if="showThreeDDashboard" class="three-d-dashboard-btn" @click="openThreeDDashboard" style="margin-right: 15px;margin-top: 1px">
            <Icon type="ios-cube" :size="48" style="color: #2d8cf0; margin-right: 6px;"></Icon>
            <span class="btn-text">{{ langMap.threeDDashboard[lang] }}</span>
          </div>
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <div class="tag-nav-wrapper">
            <tags-nav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag"/>
          </div>
          <Content class="content-wrapper">
            <keep-alive :include="cacheList" v-if="mainInitialized">
              <router-view/>
            </keep-alive>
            <div v-else class="loading-placeholder">
              <!-- 可以添加加载提示 -->
              <Spin size="large"></Spin>
            </div>
            <ABackTop :height="100" :bottom="80" :right="50" container=".content-wrapper"></ABackTop>
          </Content>
        </Layout>
      </Content>
    </Layout>

    <!-- 紧急通知容器 -->
    <div id="emergency-notification-container"></div>
  </Layout>
</template>
<script>
import api from "@/api"
import SideMenu from './components/side-menu'
import HeaderBar from './components/header-bar'
import TagsNav from './components/tags-nav'
import User from './components/user'
import ABackTop from './components/a-back-top'
import Fullscreen from './components/fullscreen'
import MessageCenter from './components/language'
import ErrorStore from './components/error-store'
import ErrorNotification from '@/view/monitor/dashboard/module/error/ErrorNotification.vue'
import { formatTime } from '@/utils/dateTimeUtil'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { getNewTagList, getNextRoute, routeEqual } from '@/libs/util'
import routers from '@/router/routers'
import minLogo from '@/assets/images/logo-min.png'
import maxLogo from '@/assets/images/logo.png'
import maxEnLogo from '@/assets/images/logo-en.png'
import userFace from '@/assets/images/user-face.jpg'
import switchSys from '@/components/switchSys/index.vue';
import Language from '@/components/Language/index.vue';
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import { connectWithUrl, releaseSocket }  from '@/utils/websocket'
import Vue from 'vue'
import { buildNotificationContent } from '@/view/monitor/dashboard/module/error/notificationContent'
import {
  beginAlertNotification,
  closeAlertNotification,
  createAlertNotificationState,
  muteAlertNotification
} from '@/view/monitor/dashboard/module/error/alertNotificationControl'

import './main.less'

export default {
  name: 'Main',
  components: {
    SideMenu,
    HeaderBar,
    MessageCenter,
    TagsNav,
    Language,
    Fullscreen,
    ErrorStore,
    User,
    ABackTop,
    switchSys
  },
  data () {
    return {
      langMap:langMap,
      collapsed: false,
      minLogo,
      maxLogo,
      maxEnLogo,
      isFullscreen: false,

      //是否显示页面
      showRouter:false,
      // 添加主组件初始化完成标识
      mainInitialized: false,
      warningNoticeId:'',
      sentimentId: '',
      warningMuteUntil: localStorage.getItem('warningMuteUntil') || 0,  // 从localStorage读取
      sentimentMuteUntil: localStorage.getItem('sentimentMuteUntil') || 0, // 从localStorage读取

      // 三维看板相关
      showThreeDDashboard: false, // 是否显示三维看板按钮
      threeDDashboardUrl: '', // 三维看板URL
      
      // 事件监听器处理器
      muteEventHandler: null,
      customEventHandler: null,
      sentimentEventHandler: null,
      pursuitNoticeClickHandler: null,
      pursuitNoticePayloads: {},
      pursuitNoticeSeen: {},
      pursuitNoticeVisible: false,
      pursuitEventNoticeQueue: [],
      pursuitEventNoticeInstances: [],
      notificationCleanups: [],
      notificationsDisposed: false,
      ssfSocket: null,
      pursuitNoticeMuteUntil: parseInt(localStorage.getItem('pursuitNoticeMuteUntil')) || 0,
      pursuitNoticeIgnoreDuration: (parseInt(localStorage.getItem('pursuitNoticeIgnoreSeconds')) || 30) * 1000,
      
      // 去重：记录最后一次通知的时间戳
      lastWarningTimestamp: 0,
      lastSentimentTimestamp: 0,
      ...createAlertNotificationState()
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    ...mapGetters([
      'errorCount'
    ]),
    tagNavList () {
      return this.$store.state.app.tagNavList
    },
    tagRouter () {
      return this.$store.state.app.tagRouter
    },
    userAvator () {
      return userFace;
    },
    cacheList () {
      return ['ParentView', ...this.tagNavList.length ? this.tagNavList.filter(item => !(item.meta && item.meta.notCache)).map(item => item.name) : []]
    },
    menuList () {
      return this.$store.state.app.sysMenulist
    },
    local () {
      return this.$store.state.app.local
    },
    hasReadErrorPage () {
      return this.$store.state.app.hasReadErrorPage
    }
  },
  watch: {
    '$route' (newRoute) {
      const { name, query, params, meta } = newRoute
      this.addTag({
        route: { name, query, params, meta },
        type: 'push'
      })
      this.setBreadCrumb(newRoute)
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
      this.$refs.sideMenu.updateOpenName(newRoute.name)
    }
  },


  created(){
    this.getUserInfo();

    // 检查是否显示三维看板按钮
    const thdime = sessionStorage.getItem('thdime');
    if (thdime === '1') {
      this.showThreeDDashboard = true;
      // 获取三维看板配置
      this.getThreeDDashboardConfig();
    }
  },


  mounted () {
    // 移除旧的监听器（如果存在）
    if (this.customEventHandler) {
      document.body.removeEventListener("custom-event", this.customEventHandler);
    }
    if (this.sentimentEventHandler) {
      document.body.removeEventListener("sentiment-custom-event", this.sentimentEventHandler);
    }
    if (this.muteEventHandler) {
      document.body.removeEventListener("mute-event", this.muteEventHandler);
    }
    
    // 添加 custom-event 监听器
    this.customEventHandler = (event) => {
       // console.log('[>>>>>>]',event.detail);
      switch (event.detail.type) {
        case 1: 
          // 检查标签栏中是否已有网枪记录页面,有则先关闭
          this.navigateToPageWithoutDuplicateTag({
            path:'/data/gunRecord',
            name: 'gunRecord',
            query: {
              timestamp: event.detail.data.data.timestamp,
              robotId: event.detail.data.robotId
            }
          });
          break;
        case 2: this.gunOperate(false, event.detail.data); break;
        case 3: this.gunOperate(true, event.detail.data); break;
        default:
      }
      this.$Notice.close(event.detail.data.code + '_gun')
    };
    document.body.addEventListener("custom-event", this.customEventHandler);
    
    // 添加 sentiment-custom-event 监听器
    this.sentimentEventHandler = (event) => {
      console.log('[>>>>>>]',event.detail);
      switch (event.detail.type) {
        case 1: 
          // 检查标签栏中是否已有告警处理页面,有则先关闭
          this.navigateToPageWithoutDuplicateTag({
            path:'/data/alarmHandling',
            name: 'alarmHandling',
            query: {
              timestamp: event.detail.data.data.timestamp,
              robotId: event.detail.data.robotId
            }
          });
          break;
        case 2: this.switchVideo(event.detail.data); break;
        case 3: this.sentimentOperate(event.detail.data); break;
        default:
      }
      this.$Notice.close(event.detail.data.code + '_sentiment')
    };
    document.body.addEventListener("sentiment-custom-event", this.sentimentEventHandler);

    // ssf 中的行为拒止消息只提供“查看详情”，详情页会自行建立 monitor WebSocket。
    this.pursuitNoticeClickHandler = (event) => {
      let target = event.target;
      while (target && target !== document.body) {
        if (target.getAttribute && target.getAttribute('data-pursuit-action') === 'detail') {
          const noticeId = target.getAttribute('data-pursuit-id');
          const payload = this.pursuitNoticePayloads[noticeId];
          if (payload) this.openPursuitDetail(payload);
          break;
        }
        target = target.parentNode;
      }
    };
    document.body.addEventListener('click', this.pursuitNoticeClickHandler);
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList()
    this.setHomeRoute(routers)
    this.addTag({
      route: this.$store.state.app.homeRoute
    })
    this.setBreadCrumb(this.$route)
    // 设置初始语言
    this.setLocal(this.$i18n.locale)
    // 如果当前打开页面不在标签栏中，跳到homeName页
    if (!this.tagNavList.find(item => item.name === this.$route.name)) {
      this.$router.push({
        name: this.$config.homeName
      })
    }

    // 添加时间单位切换函数到window对象
    window.setTimeUnit = (id, element, multiplier) => {
      // 移除其他单位的active类
      const units = element.parentElement.getElementsByClassName('time-unit');
      Array.from(units).forEach(unit => unit.classList.remove('active'));
      // 添加active类到当前单位
      element.classList.add('active');
      // 保存乘数到input的data属性
      document.getElementById(`muteTime_${id}`).dataset.multiplier = multiplier;
    };

    // 添加静默事件监听器
    this.muteEventHandler = (event) => {
      const { type, id, value } = event.detail;
      if (!value) {
        this.$Message.warning('请选择或输入时间');
        return;
      }
      this.setMuteTime(type, value);
    };
    document.body.addEventListener("mute-event", this.muteEventHandler);

    // 添加 select change 事件监听
    document.body.addEventListener("change", (event) => {
      if (event.target.classList.contains('time-select')) {
        const customInput = event.target.nextElementSibling;
        if (customInput && customInput.classList.contains('custom-time-input')) {
          customInput.style.display = event.target.value === 'custom' ? 'inline-block' : 'none';
        }
      }
    });

    // 添加全局引用以便在内联JavaScript中使用
    window.app = this;
    this.ratioW()
  },

  beforeDestroy() {
    this.notificationsDisposed = true;
    this.notificationCleanups.slice().forEach(destroy => destroy());
    this.pursuitNoticeVisible = false;
    this.pursuitNoticePayloads = {};
    this.pursuitEventNoticeQueue = [];
    this.pursuitEventNoticeInstances = [];
    delete window.app;
    const ssfSocket = this.ssfSocket;
    releaseSocket(ssfSocket, 'msgSocketUrl');
    if (ssfSocket && ssfSocket.readyState < 2) ssfSocket.close();
    this.ssfSocket = null;

    // 关闭 WebSocket 连接
    if (window._globalWebsockets && window._globalWebsockets.length > 0) {
      window._globalWebsockets.forEach(ws => {
        releaseSocket(ws);
        if (ws && ws.readyState < 2) {
          ws.close();
          console.log('WebSocket 连接已关闭');
        }
      });
      // 清空全局 WebSocket 数组
      window._globalWebsockets = [];
    }

    // 关闭所有 Notice 弹窗
    this.$Notice.destroy();

    // 移除所有事件监听器
    if (this.customEventHandler) {
      document.body.removeEventListener("custom-event", this.customEventHandler);
    }
    if (this.sentimentEventHandler) {
      document.body.removeEventListener("sentiment-custom-event", this.sentimentEventHandler);
    }
    if (this.pursuitNoticeClickHandler) {
      document.body.removeEventListener('click', this.pursuitNoticeClickHandler);
    }
    if (this.muteEventHandler) {
      document.body.removeEventListener("mute-event", this.muteEventHandler);
    }
  },

  methods: {
    ...mapMutations([
      'setBreadCrumb',
      'setTagNavList',
      'addTag',
      'setLocal',
      'setHomeRoute'
    ]),
    turnToPage (route) {
      let { name, params, query } = {}
      if (typeof route === 'string') name = route
      else {
        name = route.name
        params = route.params
        query = route.query
      }
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1])
        return
      }
      this.$router.push({
        name,
        params,
        query
      })
    },
    handleCollapsedChange (state) {
      this.collapsed = state
    },
    handleCloseTag (res, type, route) {
      if (type === 'all') {
        this.turnToPage(this.$config.homeName)
      } else if (routeEqual(this.$route, route)) {
        if (type !== 'others') {
          const nextRoute = getNextRoute(this.tagNavList, route)
          this.$router.push(nextRoute)
        }
      }
      this.setTagNavList(res)
    },
    handleClick (item) {
      this.turnToPage(item)
    },

    //更新后台允许访问菜单数组
    getUserInfo(){
      this.showRouter=false;
      this.$Spin.show();
      api.getData('system-server/user/get/home/date',this).then((res)=>{
        this.$Spin.hide();
        if(res.state==0){
          this.showRouter=false;
          //跳转错误页面
          this.$router.push({
              name: 'error_500'
          });
        }else{
          if(!res.data.menu.length){
            // 没有菜单数据，显示提示并跳转到登录页
            this.$Modal.info({
              title: langMap.noMenuPermission[this.lang],
              content: langMap.noMenuPermissionMessage[this.lang],
              okText: langMap.confirm[this.lang],
              onOk: () => {
                // 清除用户信息并跳转到登录页
                this.$store.commit('logOut');
                this.$router.push({
                  name: 'login'
                });
              }
            });
            return;
          }
          // 用户信息不完整（无 loginUser 或缺少 userId）视为会话数据异常，
          // 不渲染业务页，避免后续页面读取到 undefined 的 userId
          if(!res.data.loginUser || !res.data.loginUser.userId){
            this.showRouter=false;
            this.$router.push({
              name: 'error_500'
            });
            return;
          }
          //保存全局动态菜单数据
          this.$store.commit('updateMenulist',res.data.menu);
          this.$store.commit('muChnageUserInfo', res.data.loginUser);
          this.$store.commit('setBreadCrumb', this.$route);
          this.showRouter=true;
          //console.log(res.data.loginUser)
          this.socketInit('msgSocketUrl', res.data.loginUser.userId, this.callback, this);

          this.loadComplete()
          // this.warning({data:{msg:'请求打开网枪',img:''}});
        }
      })
    },
    socketInit(key, userId, callback, _this){
      if (this.notificationsDisposed) return;
      const previous = this.ssfSocket;
      releaseSocket(previous, key);
      if (previous && previous.readyState < 2) previous.close();
      this.ssfSocket = connectWithUrl('/ssf', key, userId, callback);
    },
    loadComplete() {
      this.$nextTick(() => {
        // 通知全局主组件已初始化完成
        this.mainInitialized = true;
      });
    },
    callback(data){
      if (this.notificationsDisposed) return;
      let ret;
      try {
        ret = typeof data === 'string' ? JSON.parse(data) : data;
      } catch (error) {
        console.warn('[ssf] invalid message', error);
        return;
      }
      if (!ret || !ret.type) return;
      switch (ret.type) {
        case '1':
          this.$Notice.info({
            title: langMap.systemMessage[this.lang],
            desc: ret.data
          });
          break;
          case 'gun:': this.warning(ret); break;
          case 'sentiment:': this.sentiment(ret); break;
          case 'emergency_info':
          case 'alert_info': this.emergencyNotice(ret); break;
          case 'pursuit_detection':
          case 'pursuit_event': this.pursuitNotice(ret); break;
          default:
      }
    },
    escapeHtml(value) {
      return String(value === null || value === undefined ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },
    createPursuitNoticeHtml(payload, noticeId) {
      const eventStatusKeys = {
        AUTHORIZING: 'pursuitStatusAuthorizing', ACTIVE: 'pursuitStatusActive', AUTHORIZE_FAILED: 'pursuitStatusAuthorizeFailed', AUTHORIZE_TIMEOUT: 'pursuitStatusAuthorizeTimeout',
        CANCELLING: 'pursuitStatusCancelling', CANCEL_FAILED: 'pursuitStatusCancelFailed', CANCEL_TIMEOUT: 'pursuitStatusCancelTimeout',
        CANCELED: 'pursuitStatusCanceled', STATE_TIMEOUT: 'pursuitStatusPlatformClosed', OFFLINE_CLOSED: 'pursuitStatusPlatformClosed'
      };
      const pursuitStateKeys = { DETECTING: 'pursuitTrackingDetecting', TRACKING: 'pursuitTracking', TEMP_LOST: 'pursuitTrackingLost' };
      const typeKeys = { pursuit_detection: 'pursuitNoticeDetection', pursuit_state: 'pursuitNoticeTracking', pursuit_event: 'pursuitNoticeEvent' };
      const translate = key => (langMap[key] && (langMap[key][this.lang] || langMap[key].zh)) || key;
      const typeText = translate(typeKeys[payload.type] || 'pursuitNoticeFallback');
      const rawState = payload.state || payload.eventStatus || '';
      const stateText = translate(pursuitStateKeys[rawState] || eventStatusKeys[rawState] || '') || rawState || translate('pursuitNoticePending');
      const stateClass = String(rawState).replace(/[^a-zA-Z0-9_-]/g, '') || 'unknown';
      const targetText = payload.targetId || (payload.targetIds && payload.targetIds.join(', ')) || translate('pursuitNoticeUnspecified');
      const typeClass = String(payload.type || '').replace(/[^a-zA-Z0-9_-]/g, '') || 'unknown';
      return '<div class="pursuit-notice">' +
        '<div class="pursuit-notice-line pursuit-notice-type-row"><span>' + translate('pursuitNoticeType') + '</span><strong class="pursuit-notice-type pursuit-type-' + typeClass + '">' + this.escapeHtml(typeText) + '</strong></div>' +
        '<div class="pursuit-notice-line pursuit-notice-code-row"><span>' + translate('pursuitNoticeCode') + '</span><strong class="pursuit-notice-code">' + this.escapeHtml(payload.code || '-') + '</strong></div>' +
        '<div class="pursuit-notice-line pursuit-notice-state-row"><span>' + translate('pursuitNoticeTargetState') + '</span><strong class="pursuit-notice-state pursuit-state-' + stateClass + '"><b>' + this.escapeHtml(targetText) + '</b><i>·</i><em>' + this.escapeHtml(stateText) + '</em></strong></div>' +
        '<button type="button" class="pursuit-notice-detail" data-pursuit-action="detail" data-pursuit-id="' + this.escapeHtml(noticeId) + '">' + translate('pursuitNoticeDetail') + '</button>' +
        '</div>';
    },
    resolvePursuitImage(data) {
      if (!data || typeof data !== 'object') return '';
      return data.sourceAnnotatedImageUrl || data.annotatedImageUrl || data.imageUrl ||
        data.sourceImageUrl || data.image || data.img || '';
    },
    createPursuitImageHtml(payload) {
      const imageUrl = this.resolvePursuitImage(payload);
      const typeKeys = { pursuit_detection: 'pursuitNoticeDetection', pursuit_state: 'pursuitNoticeTracking', pursuit_event: 'pursuitNoticeEvent' };
      const typeKey = typeKeys[payload.type] || 'pursuitNoticeFallback';
      const typeLabel = langMap[typeKey] ? (langMap[typeKey][this.lang] || langMap[typeKey].zh) : payload.type;
      const codeLabel = langMap.pursuitNoticeCode ? (langMap.pursuitNoticeCode[this.lang] || langMap.pursuitNoticeCode.zh) : 'Ball Code';
      const typeLabelText = langMap.pursuitNoticeType ? (langMap.pursuitNoticeType[this.lang] || langMap.pursuitNoticeType.zh) : 'Type';
      const timeLabel = langMap.pursuitDetectionTime ? (langMap.pursuitDetectionTime[this.lang] || langMap.pursuitDetectionTime.zh) : 'Detection Time';
      const rawTimestamp = payload.reportTimestamp || payload.sourceReportTimestamp;
      const numericTimestamp = Number(rawTimestamp);
      const timestamp = rawTimestamp !== undefined && rawTimestamp !== null && rawTimestamp !== ''
        ? (Number.isFinite(numericTimestamp) ? numericTimestamp : rawTimestamp)
        : null;
      const date = timestamp === null ? null : new Date(timestamp);
      const detectionTime = date && !Number.isNaN(date.getTime()) ? formatTime(date.getTime()) : '-';
      const rows = '<div class="pursuit-notification-meta">' +
        '<div class="pursuit-notification-meta-row"><span>' + this.escapeHtml(typeLabelText) + '</span><strong class="pursuit-notification-type">' + this.escapeHtml(typeLabel || '-') + '</strong></div>' +
        '<div class="pursuit-notification-meta-row"><span>' + this.escapeHtml(timeLabel) + '</span><strong class="pursuit-notification-time">' + this.escapeHtml(detectionTime) + '</strong></div>' +
        '<div class="pursuit-notification-meta-row"><span>' + this.escapeHtml(codeLabel) + '</span><strong class="pursuit-notification-code">' + this.escapeHtml(payload.code || '-') + '</strong></div>' +
        '</div>';
      const image = imageUrl ? '<img class="pursuit-notification-image" src="' + this.escapeHtml(imageUrl) + '" alt="" />' : '';
      return rows + image;
    },
    createPursuitEventHtml(payload) {
      const eventStatusKeys = {
        AUTHORIZING: 'pursuitStatusAuthorizing', ACTIVE: 'pursuitStatusActive', AUTHORIZE_FAILED: 'pursuitStatusAuthorizeFailed', AUTHORIZE_TIMEOUT: 'pursuitStatusAuthorizeTimeout',
        CANCELLING: 'pursuitStatusCancelling', CANCEL_FAILED: 'pursuitStatusCancelFailed', CANCEL_TIMEOUT: 'pursuitStatusCancelTimeout',
        CANCELED: 'pursuitStatusCanceled', STATE_TIMEOUT: 'pursuitStatusPlatformClosed', OFFLINE_CLOSED: 'pursuitStatusPlatformClosed'
      };
      const operationStatusKeys = {
        CREATED: 'pursuitOperationPreparing', SENT: 'pursuitOperationWaiting', ACK_OK: 'pursuitOperationSuccess',
        ACK_FAILED: 'pursuitOperationFailed', SEND_FAILED: 'pursuitSendFailed', TIMEOUT: 'pursuitResponseTimeout', STALE: 'pursuitStale'
      };
      const translate = key => (langMap[key] && (langMap[key][this.lang] || langMap[key].zh)) || key;
      const value = (labelKey, valueText, className) =>
        '<div class="pursuit-notification-meta-row"><span>' + translate(labelKey) + '</span><strong class="' + className + '" title="' + this.escapeHtml(valueText || '-') + '">' + this.escapeHtml(valueText || '-') + '</strong></div>';
      const operationTypeKeys = { AUTHORIZE: 'pursuitAuthorizeShort', CANCEL: 'pursuitCancelShort' };
      const operationType = payload.operationType && operationTypeKeys[payload.operationType]
        ? translate(operationTypeKeys[payload.operationType])
        : payload.operationType;
      const operationStatus = payload.operationStatus && operationStatusKeys[payload.operationStatus]
        ? translate(operationStatusKeys[payload.operationStatus])
        : payload.operationStatus;
      const eventStatus = payload.eventStatus && eventStatusKeys[payload.eventStatus]
        ? translate(eventStatusKeys[payload.eventStatus])
        : payload.eventStatus;
      const operationTone = /FAILED|TIMEOUT/.test(payload.operationStatus || '')
        ? 'is-error'
        : payload.operationStatus === 'ACK_OK'
          ? 'is-success'
          : payload.operationStatus
            ? 'is-pending'
            : 'is-muted';
      const eventTone = payload.eventStatus === 'ACTIVE'
        ? 'is-success'
        : /FAILED|TIMEOUT/.test(payload.eventStatus || '')
          ? 'is-error'
          : /CANCELED|OFFLINE_CLOSED|STATE_TIMEOUT/.test(payload.eventStatus || '')
            ? 'is-muted'
            : payload.eventStatus
              ? 'is-pending'
              : 'is-muted';
      const feedback = this.lang === 'en'
        ? payload.lastFeedbackMessageEn || payload.lastFeedbackMessageZh || payload.lastFeedbackMessage
        : payload.lastFeedbackMessageZh || payload.lastFeedbackMessageEn || payload.lastFeedbackMessage;
      return '<div class="pursuit-notification-meta pursuit-notification-event-meta">' +
        value('pursuitTargetId', payload.targetId, 'pursuit-notification-target') +
        value('pursuitOperationType', operationType, 'pursuit-notification-operation-type') +
        value('pursuitOperationStatus', operationStatus, 'pursuit-notification-operation-status ' + operationTone) +
        value('pursuitEventStatus', eventStatus, 'pursuit-notification-event-status ' + eventTone) +
        value('pursuitLatestFeedback', feedback, 'pursuit-notification-feedback') +
        '</div>';
    },
    mutePursuitNotice(seconds) {
      const value = Number(seconds);
      const muteSeconds = Number.isFinite(value) && value > 0
        ? value
        : Math.max(1, Math.floor(this.pursuitNoticeIgnoreDuration / 1000));
      this.pursuitNoticeIgnoreDuration = muteSeconds * 1000;
      this.pursuitNoticeMuteUntil = Date.now() + this.pursuitNoticeIgnoreDuration;
      this.pursuitNoticeVisible = false;
      this.showNextPursuitEventNotice();
      localStorage.setItem('pursuitNoticeIgnoreSeconds', String(muteSeconds));
      localStorage.setItem('pursuitNoticeMuteUntil', String(this.pursuitNoticeMuteUntil));
    },
    pursuitNotice(ret) {
      if (this.notificationsDisposed) return;
      const data = ret && ret.data && typeof ret.data === 'object' ? ret.data : {};
      const source = data.event && typeof data.event === 'object' ? { ...data, ...data.event } : data;
      const operation = source.operation && typeof source.operation === 'object' ? source.operation : {};
      const payload = {
        type: ret.type,
        code: source.code || ret.robotCode || '',
        targetIds: Array.isArray(source.targetIds) ? source.targetIds : [],
        targetId: source.targetId || (Array.isArray(source.targetIds) ? source.targetIds[0] || '' : ''),
        reportTimestamp: source.reportTimestamp || source.sourceReportTimestamp || '',
        eventId: source.eventId || '',
        state: source.state || source.pursuitState || '',
        eventStatus: source.eventStatus || '',
        operationType: operation.operationType || source.operationType || '',
        operationStatus: operation.operationStatus || source.operationStatus || '',
        lastFeedbackMessage: source.lastFeedbackMessage || source.feedbackMessage || '',
        lastFeedbackMessageZh: source.lastFeedbackMessageZh || source.feedbackMessageZh || '',
        lastFeedbackMessageEn: source.lastFeedbackMessageEn || source.feedbackMessageEn || '',
        imageUrl: this.resolvePursuitImage(source)
      };
      const isEvent = payload.type === 'pursuit_event';
      if (!payload.code && !isEvent) return;

      const now = Date.now();
      const isDetection = payload.type === 'pursuit_detection';
      if (isEvent) {
        if (this.pursuitNoticeVisible) this.pursuitEventNoticeQueue.push(payload);
        else this.showPursuitEventNotice(payload);
        return;
      }
      if ((isDetection && now < this.pursuitNoticeMuteUntil) || this.pursuitNoticeVisible || this.pursuitEventNoticeInstances.length || this.pursuitEventNoticeQueue.length) return;
      const noticeHtml = isDetection
        ? this.createPursuitImageHtml(payload)
        : payload.type === 'pursuit_event'
          ? this.createPursuitEventHtml(payload)
          : '';
      if (!noticeHtml) return;

      const identity = [payload.type, payload.code, payload.eventId, payload.reportTimestamp, payload.targetId, payload.state, payload.eventStatus].join('|');
      if (this.pursuitNoticeSeen[identity] && now - this.pursuitNoticeSeen[identity] < 1500) return;
      this.pursuitNoticeSeen[identity] = now;
      Object.keys(this.pursuitNoticeSeen).forEach(key => {
        if (now - this.pursuitNoticeSeen[key] > 60000) delete this.pursuitNoticeSeen[key];
      });

      const noticeId = ('pursuit_' + payload.type + '_' + payload.code + '_' + (payload.eventId || payload.reportTimestamp || now)).replace(/[^a-zA-Z0-9_-]/g, '_');
      payload.noticeId = noticeId;
      if (isDetection) this.pursuitNoticePayloads[noticeId] = payload;
      this.pursuitNoticeVisible = true;
      this.showErrorNotificationInstance({
        title: (langMap.pursuitNoticeTitle && (langMap.pursuitNoticeTitle[this.lang] || langMap.pursuitNoticeTitle.zh)) || 'Pursuit Denial Message',
        description: noticeHtml,
        type: 'warning',
        duration: isDetection ? 10000 : 3000,
        robotId: payload.code,
        showIgnore: isDetection,
        ignoreDefaultSeconds: Math.max(1, Math.floor(this.pursuitNoticeIgnoreDuration / 1000)),
        detailLabel: isDetection ? langMap.pursuitNoticeDetail[this.lang] : '',
        onClose: () => {
          this.pursuitNoticeVisible = false;
          delete this.pursuitNoticePayloads[noticeId];
          this.showNextPursuitEventNotice();
        },
        onIgnore: (_, seconds) => {
          this.mutePursuitNotice(seconds);
          delete this.pursuitNoticePayloads[noticeId];
          this.showNextPursuitEventNotice();
        },
        onDetail: isDetection ? () => {
          this.pursuitNoticeVisible = false;
          delete this.pursuitNoticePayloads[noticeId];
          this.openPursuitDetail(payload);
          this.showNextPursuitEventNotice();
        } : undefined
      });
    },
    showNextPursuitEventNotice() {
      if (this.notificationsDisposed || this.pursuitNoticeVisible || !this.pursuitEventNoticeQueue.length) return;
      const pending = this.pursuitEventNoticeQueue.splice(0);
      pending.forEach(payload => this.showPursuitEventNotice(payload));
    },
    showPursuitEventNotice(payload) {
      if (this.notificationsDisposed) return;
      const noticeHtml = this.createPursuitEventHtml(payload);
      if (!noticeHtml) {
        this.showNextPursuitEventNotice();
        return;
      }
      let instance;
      instance = this.showErrorNotificationInstance({
        title: (langMap.pursuitNoticeTitle && (langMap.pursuitNoticeTitle[this.lang] || langMap.pursuitNoticeTitle.zh)) || 'Pursuit Denial Message',
        description: noticeHtml,
        type: 'warning',
        duration: 2000,
        robotId: payload.code || '-',
        showIgnore: false,
        detailLabel: '',
        onClose: () => {
          this.pursuitEventNoticeInstances = this.pursuitEventNoticeInstances.filter(item => item !== instance);
          this.positionPursuitEventNotices();
        }
      });
      if (instance) {
        this.pursuitEventNoticeInstances.push(instance);
        this.positionPursuitEventNotices();
      }
    },
    positionPursuitEventNotices() {
      this.$nextTick(() => {
        let top = 80;
        this.pursuitEventNoticeInstances.forEach(instance => {
          const notification = instance && instance.$el && instance.$el.querySelector('.error-notification');
          if (!notification) return;
          notification.style.top = top + 'px';
          top += notification.getBoundingClientRect().height + 12;
        });
      });
    },
    openPursuitDetail(payload) {
      const query = {};
      ['code', 'targetId', 'reportTimestamp', 'eventId'].forEach(key => {
        if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') query[key] = String(payload[key]);
      });
      if (payload.reportTimestamp) {
        const timestamp = String(payload.reportTimestamp);
        query.startTimestamp = timestamp;
        query.endTimestamp = timestamp;
      }
      if (payload.type) query.type = payload.type;
      const noticeId = payload.noticeId || ('pursuit_' + payload.type + '_' + payload.code + '_' + (payload.eventId || payload.reportTimestamp || '')).replace(/[^a-zA-Z0-9_-]/g, '_');
      this.$Notice.close(noticeId);
      this.navigateToPageWithoutDuplicateTag({ path: '/control/pursuit', name: 'pursuit', query });
    },
    createNoticeHtml(data, type) {
      const id = type === 'warning' ?
        data.data.code + '_gun' :
        data.data.code + '_sentiment';

      const customEvent = type === 'warning' ?
        'custom-event' :
        'sentiment-custom-event';

      return `
        <div class="notice-container">
          <h2 class="notice-title">${this.langMap.targetDetected[this.lang]}</h2>
          <img class="notice-img" src="${data.data.img}"/>
          <div class="notice-content">
            <div class="mute-settings">
              <div class="time-input-wrapper">
                <div class="error-tip" id="errorTip_${id}"></div>
                <span class="mute-label">${this.langMap.ignore[this.lang]}:</span>
                <select class="time-select" id="muteTime_${id}">
                  <option value="30">30${this.langMap.second[this.lang]}</option>
                  <option value="60">60${this.langMap.second[this.lang]}</option>
                  <option value="90">90${this.langMap.second[this.lang]}</option>
                  <option value="120">120${this.langMap.second[this.lang]}</option>
                  <option value="custom">${this.langMap.customize[this.lang]}</option>
                </select>
                <input type="number" class="custom-time-input" id="customTime_${id}" style="display:none" min="1" placeholder="${this.langMap.second[this.lang]}"/>
                <button class="mute-confirm" onclick='javascript:
                  try {
                    var errorTip = document.getElementById("errorTip_${id}");
                    var select = document.getElementById("muteTime_${id}");
                    var customInput = document.getElementById("customTime_${id}");
                    errorTip.textContent = ""; // 清除之前的错误提示

                    if (!select) {
                      errorTip.textContent = "系统错误：找不到选择框元素";
                      return;
                    }
                    var value = select.value;
                    if (value === "custom") {
                      value = customInput.value;
                      if (!value) {
                        errorTip.textContent = "${this.langMap.PleaseInputTime[this.lang]}";
                        customInput.focus();
                        return;
                      }
                      if (value <= 0) {
                        errorTip.textContent = "${this.langMap.PleaseInputMax[this.lang]}";
                        customInput.focus();
                        return;
                      }
                    }
                    document.body.dispatchEvent(new CustomEvent("mute-event", {
                      detail: {
                        type: "${type}",
                        id: "${id}",
                        value: value
                      }
                    }));
                  } catch(e) {
                    errorTip.textContent = e.message;
                  }
                '>${this.langMap.confirm[this.lang]}</button>
              </div>
            </div>
            <div class="action-buttons">
              <Button class="btn primary" onclick='javascript:var k = new CustomEvent("${customEvent}",{detail:${JSON.stringify({type:1,data:data})}});document.body.dispatchEvent(k);'>${this.langMap.details[this.lang]}</Button>
              <Button class="btn danger" onclick='javascript:var k = new CustomEvent("${customEvent}",{detail:${JSON.stringify({type:3,data:data})}});document.body.dispatchEvent(k);'>${type === 'warning' ? this.langMap.allow[this.lang] : this.langMap.noDeal[this.lang]}</Button>
            </div>
          </div>
        </div>`;
    },

    showNotice(data, type) {
      const currentTime = Date.now();
      const storageKey = type === 'warning' ? 'warningMuteUntil' : 'sentimentMuteUntil';
      const savedMuteUntil = parseInt(localStorage.getItem(storageKey)) || 0;

      // 检查是否在静默期
      if (currentTime < savedMuteUntil) {
        return;
      }

      const id = type === 'warning' ?
        data.data.code + '_gun' :
        data.data.code + '_sentiment';
      
      // 去重：500ms 内不重复显示同一条通知
      const lastTimestamp = type === 'warning' ? this.lastWarningTimestamp : this.lastSentimentTimestamp;
      const messageId = data.data.messageId || data.data.code;
      if (currentTime - lastTimestamp < 500 && (type === 'warning' ? this.warningNoticeId : this.sentimentId) === id) {
        return;
      }
      
      if (type === 'warning') {
        this.lastWarningTimestamp = currentTime;
      } else {
        this.lastSentimentTimestamp = currentTime;
      }

      // 关闭之前的通知
      this.$Notice.close(type === 'warning' ? this.warningNoticeId : this.sentimentId);

      // 保存当前通知ID
      if (type === 'warning') {
        this.warningNoticeId = id;
      } else {
        this.sentimentId = id;
      }

      // 显示通知
      this.$Notice.warning({
        key: id,
        name: id,
        title: this.langMap.robot[this.lang] + ':' + data.data.code,
        desc: this.createNoticeHtml(data, type),
        duration: 0
      });
    },

    warning(data) {
      this.showNotice(data, 'warning');
    },

    sentiment(data) {
      this.showNotice(data, 'sentiment');
    },

    showErrorNotificationInstance({
      title,
      description,
      robotId,
      ignoreDefaultSeconds,
      detailLabel,
      showIgnore = true,
      type = 'emergency',
      duration = 10000,
      onClose,
      onIgnore,
      onDetail
    }) {
      if (this.notificationsDisposed) return null;
      const container = document.createElement('div')
      document.body.appendChild(container)

      const NotificationConstructor = Vue.extend(ErrorNotification);
      const instance = new NotificationConstructor({
        parent: this,
        propsData: {
          title,
          description,
          type,
          duration,
          robotId,
          ignoreDefaultSeconds,
          detailLabel,
          showIgnore
        }
      })

      let destroyed = false
      const destroyInstance = () => {
        if (destroyed) return
        destroyed = true
        const index = this.notificationCleanups.indexOf(destroyInstance)
        if (index !== -1) this.notificationCleanups.splice(index, 1)
        if (!instance._isDestroyed) instance.$destroy()
        if (container.parentNode) {
          container.parentNode.removeChild(container)
        }
      }
      this.notificationCleanups.push(destroyInstance)
      instance.$on('hook:destroyed', destroyInstance)

      instance.$on('close', () => {
        try {
          if (onClose) onClose()
        } finally { destroyInstance() }
      })

      instance.$on('ignore', (...args) => {
        try {
          if (onIgnore) onIgnore(...args)
        } finally { destroyInstance() }
      })

      instance.$on('detail', () => {
        try {
          if (onDetail) onDetail()
        } finally { destroyInstance() }
      })

      instance.$mount()
      container.appendChild(instance.$el)
      return instance
    },

    emergencyNotice(data) {
      const sourceType = data.type === 'alert_info' ? 'alert_info' : 'emergency_info'

      if (sourceType === 'alert_info' && !beginAlertNotification(this)) return

      const notice = buildNotificationContent(
        sourceType,
        data,
        key => this.langMap[key] ? this.langMap[key][this.lang] : key
      )

      if (sourceType === 'emergency_info') {
        this.showErrorNotificationInstance(notice)
        return
      }

      this.showErrorNotificationInstance({
        ...notice,
        ignoreDefaultSeconds: Math.max(1, Math.floor(this.alertInfoIgnoreDuration / 1000)),
        onClose: () => {
          closeAlertNotification(this)
        },
        onIgnore: (_, seconds) => {
          muteAlertNotification(this, seconds)
        }
      })
    },

    gunOperate(type, data){
      this.$Modal.confirm({
        title: langMap.systemTip[this.lang],
        content: type ? langMap.confirmOpenNetGun[this.lang] : langMap.confirmRejectOperation[this.lang],
        onOk: () => {
          this.$Spin.show();
          let d = {
            timestamp: data.data.timestamp,
            flag: type
          };
          const code = data ? data.data.code : undefined
          api
            .postData("notice-server/cmd/gun", { robotId: data.robotId,code, data: d }, this)
            .then(res => {
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.tip[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.success[this.lang],
                  desc: res.message
                });
              }
              this.$Spin.hide();
            });
        }
      });
    },
    switchVideo(data) {
      let routedata = this.$router.resolve({
        path: "/lol",
        query: {
          id: data.robotId,
          timestamp: data.data.timestamp,
        }
      });
      window.open(routedata.href, "_blank");
    },
    sentimentOperate(data){
      this.$Modal.confirm({
        title: langMap.systemTip[this.lang],
        content: langMap.confirmIgnoreAlarm[this.lang],
        onOk: () => {
          this.$Spin.show();
          let d = {
            timestamp: data.data.timestamp,
            ret: 4
          };
          const code = data ? data.data.code : undefined
          api
            .postData("notice-server/cmd/sentiment", { robotId: data.robotId,code, data: d }, this)
            .then(res => {
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.tips[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.success[this.lang],
                  desc: res.message
                });
              }
              this.$Spin.hide();
            });
        }
      });
    },
    // 设置静默时间
    setMuteTime(type, seconds) {
      const value = parseInt(seconds);
      if (!value || value <= 0) {
        this.$Message.warning({
          content: this.langMap.enterValidTime[this.lang],
          duration: 3
        });
        return;
      }

      const muteUntil = Date.now() + value * 1000;

      if (type === 'warning') {
        this.warningMuteUntil = muteUntil;
        localStorage.setItem('warningMuteUntil', muteUntil);
        this.$Notice.close(this.warningNoticeId);
      } else {
        this.sentimentMuteUntil = muteUntil;
        localStorage.setItem('sentimentMuteUntil', muteUntil);
        this.$Notice.close(this.sentimentId);
      }

      const reminderMsg = this.langMap.reminderNotGiveAgain[this.lang].replace('{seconds}', value);
      this.$Message.success({
        content: reminderMsg,
        duration: 3
      });
    },
    //自适应屏幕
    ratioW(text) {
      var targetWidth = text || 1600;
      var style = document.createElement("style");
      style.innerHTML = `
         body {
           width: 100%;
           height: 100%;
           margin: 0;
         }
         `;
      document.head.appendChild(style);

      let adjustWindow = () => {
        let ratio = window.innerWidth / targetWidth;
        if (ratio > 1) ratio = 1;
        const defaultZoom = document.documentElement.getAttribute("defaultZoom")
        if(defaultZoom){
          ratio = parseFloat(ratio > defaultZoom ? defaultZoom : ratio)
        }
        document.documentElement.style.zoom = ratio;

        document.documentElement.setAttribute("data-ratio", ratio);
      };
      adjustWindow();
      window.addEventListener("resize", adjustWindow);
      // 使鼠标坐标一致
      let x_get = Object.getOwnPropertyDescriptor(MouseEvent.prototype, "x").get;
      let y_get = Object.getOwnPropertyDescriptor(MouseEvent.prototype, "y").get;
      Object.defineProperties(MouseEvent.prototype, {
        R: {
          get: function () {
            return parseFloat(document.documentElement.getAttribute("data-ratio"));
          },
        },
        x: {
          get: function () {
            return x_get.call(this) / this.R;
          },
        },
        y: {
          get: function () {
            return y_get.call(this) / this.R;
          },
        },
      });
    },

    // 获取三维看板配置
    getThreeDDashboardConfig() {
      api.getData("system-server/config/list?keys=3dDashboardUrl").then(r => {
        if (r.state == 0) {
          console.error(r.msg);
        } else {
          let config = r.data['3dDashboardUrl']
          if (config && config.configValue) {
            this.threeDDashboardUrl = config.configValue
          }
        }
      })
    },

    // 打开三维看板
    openThreeDDashboard() {
      if (!this.threeDDashboardUrl) {
        this.$Message.error(this.langMap.swConfigNotFound[this.lang]);
        return;
      }
      try {
        // 跳转到三维看板
        window.location.href = this.threeDDashboardUrl;
      } catch (error) {
        console.error('Error opening 3D dashboard:', error);
        this.$Message.error(this.langMap.openFailed[this.lang]);
      }
    },

    // 跳转到页面，避免重复标签
    navigateToPageWithoutDuplicateTag(routeConfig) {
      const { name, path, query } = routeConfig;
      
      // 检查标签栏中是否已存在同名路由
      const existingTag = this.tagNavList.find(item => item.name === name);
      
      if (existingTag) {
        // 如果已存在，先关闭旧标签
        const newTagList = this.tagNavList.filter(item => item.name !== name);
        this.setTagNavList(newTagList);
      }
      
      // 跳转到新路由（watch 会自动添加新标签）
      this.$router.push({ path, query });
    }
  }

}
</script>
<style>
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active, .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active:hover{
    background: #EC5336 !important;
  }
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title{
    background:#0f0f0f !important;
  }
  .ivu-menu-vertical,.ivu-menu-opened{
    background:#0f0f0f !important;
  }
  .ivu-menu-dark{
    background: #030202 !important;
  }
  .ivu-layout-sider{
    background: #030202 !important;
  }
  .btn{
    margin: 5px;
    padding: 5px 10px;
  }
  .mute-select-container {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .mute-select {
    width: 100px;
  }

  .mute-confirm {
    margin-left: 8px;
  }

  .notice-container {
    padding: 8px;
  }

  .pursuit-notice {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    padding: 5px 0 0;
  }

  .error-notification .pursuit-notification-image {
    display: block;
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: min(42vh, 360px);
    margin: 0 auto;
    box-sizing: border-box;
    min-height: 0;
    aspect-ratio: auto;
    object-fit: contain;
    border: 1px solid rgba(255, 152, 0, .45);
    border-radius: 6px;
    background: #061624;
    box-shadow: 0 0 14px rgba(255, 152, 0, .18);
  }
  .error-notification .pursuit-notification-meta {
    margin-bottom: 10px;
    display: grid;
    gap: 6px;
  }
  .error-notification .pursuit-notification-meta-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-height: 26px;
    padding: 3px 8px;
    border: 1px solid rgba(255, 152, 0, .22);
    border-radius: 5px;
    background: rgba(255, 152, 0, .06);
    color: rgba(255, 255, 255, .68);
    font-size: 12px;
  }
  .error-notification .pursuit-notification-meta-row > span {
    flex: 0 0 72px;
    min-width: 72px;
    white-space: nowrap;
  }
  .error-notification:has(.pursuit-notification-event-meta) {
    width: 560px;
    max-width: calc(100vw - 32px);
  }
  .error-notification .pursuit-notification-event-meta .pursuit-notification-meta-row strong {
    flex: 1 1 auto;
    text-align: left;
  }
  .error-notification .pursuit-notification-event-meta .pursuit-notification-meta-row {
    justify-content: flex-start;
  }
  .error-notification .pursuit-notification-meta-row strong {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: Consolas, 'Courier New', monospace;
    font-weight: 600;
    text-align: right;
  }
  .error-notification .pursuit-notification-type { color: #16dfe7; }
  .error-notification .pursuit-notification-time { color: #83c9ff; }
  .error-notification .pursuit-notification-code { color: #ffd166; }
  .error-notification .pursuit-notification-target { color: #16dfe7; }
  .error-notification .pursuit-notification-operation-type { color: #ffd166; }
  .error-notification .pursuit-notification-operation-status.is-success,
  .error-notification .pursuit-notification-event-status.is-success { color: #54e39b; }
  .error-notification .pursuit-notification-operation-status.is-error,
  .error-notification .pursuit-notification-event-status.is-error { color: #ff8b8b; }
  .error-notification .pursuit-notification-operation-status.is-pending,
  .error-notification .pursuit-notification-event-status.is-pending { color: #ffc857; }
  .error-notification .pursuit-notification-operation-status.is-muted,
  .error-notification .pursuit-notification-event-status.is-muted { color: #b9c8cf; }
  .error-notification .pursuit-notification-feedback { color: #d890cf; }

  /* iView gives Notice descriptions a narrow fixed column; behavior-denial
     notices need the full card width so IDs and state text remain readable. */
  .ivu-notice-notice:has(.pursuit-notice) {
    width: 360px !important;
    max-width: calc(100vw - 32px) !important;
    box-sizing: border-box;
    padding: 15px 18px 17px !important;
    border: 1px solid rgba(78, 201, 236, .5);
    border-radius: 6px;
    background: linear-gradient(135deg, rgba(8, 34, 52, .98), rgba(3, 18, 31, .98)) !important;
    box-shadow: 0 8px 24px rgba(0, 10, 20, .42), inset 0 1px 0 rgba(195, 241, 255, .08);
  }

  .ivu-notice-notice:has(.pursuit-notice) .ivu-notice-content,
  .ivu-notice-notice:has(.pursuit-notice) .ivu-notice-desc {
    width: 100% !important;
    max-width: none !important;
    box-sizing: border-box;
    overflow: visible;
  }

  .ivu-notice-notice:has(.pursuit-notice) .ivu-notice-desc {
    margin-left: 0 !important;
    padding-right: 2px;
  }

  .ivu-notice-notice:has(.pursuit-notice) .ivu-notice-title {
    position: relative;
    margin-bottom: 10px;
    padding: 0 22px 10px 12px;
    border-bottom: 1px solid rgba(78, 201, 236, .28);
    color: #f3fcff;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: .4px;
  }

  .ivu-notice-notice:has(.pursuit-notice) .ivu-notice-title::before {
    content: '';
    position: absolute;
    top: 1px;
    bottom: 11px;
    left: 0;
    width: 3px;
    border-radius: 2px;
    background: linear-gradient(180deg, #ffd166, #ff8f5b);
    box-shadow: 0 0 9px rgba(255, 209, 102, .6);
  }

  .ivu-notice-notice:has(.pursuit-notice) .ivu-notice-close {
    color: #9abac5;
  }

  .ivu-notice-notice:has(.pursuit-notice) .ivu-notice-close:hover {
    color: #f5fdff;
  }

  .pursuit-notice-line {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 29px;
    color: #7d99a3;
    font-size: 12px;
    line-height: 1.35;
    padding: 3px 8px;
    border: 1px solid rgba(80, 193, 231, .14);
    border-radius: 6px;
    background: linear-gradient(100deg, rgba(18, 80, 112, .3), rgba(3, 35, 61, .22));
    box-sizing: border-box;
  }

  .pursuit-notice-line:nth-child(odd) {
    background: linear-gradient(100deg, rgba(21, 96, 126, .24), rgba(3, 35, 61, .16));
  }

  .pursuit-notice-line strong {
    min-width: 0;
    flex: 1;
    overflow: hidden;
    font-family: Consolas, 'Courier New', monospace;
    font-weight: 500;
    text-overflow: ellipsis;
    text-align: right;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .pursuit-notice-line > span {
    flex: 0 0 58px;
    color: #82a1ab;
  }

  .pursuit-notice-type,
  .pursuit-notice-code,
  .pursuit-notice-state {
    color: #eafcff;
  }

  .pursuit-notice-type {
    color: #10dce5;
  }

  .pursuit-notice-code {
    color: #ffd166;
  }

  .pursuit-notice-state {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    font-family: inherit;
    white-space: normal;
  }

  .pursuit-notice-state b,
  .pursuit-notice-state em {
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
    font-style: normal;
  }

  .pursuit-notice-state b {
    color: #ff69c9;
  }

  .pursuit-notice-state i {
    color: #718891;
    font-style: normal;
  }

  .pursuit-type-pursuit_detection + .pursuit-notice-state,
  .pursuit-state-pursuit_detection em {
    color: #ffc857;
  }

  .pursuit-state-pursuit_state em {
    color: #21dfe4;
  }

  .pursuit-state-pursuit_event em {
    color: #54e39b;
  }

  .pursuit-state-unknown em {
    color: #c8d4d8;
  }

  .pursuit-state-ACTIVE em,
  .pursuit-state-AUTHORIZING em,
  .pursuit-state-CANCELLING em {
    color: #54e39b;
  }

  .pursuit-state-AUTHORIZE_FAILED em,
  .pursuit-state-AUTHORIZE_TIMEOUT em,
  .pursuit-state-CANCEL_FAILED em,
  .pursuit-state-CANCEL_TIMEOUT em {
    color: #ff8b8b;
  }

  .pursuit-state-CANCELED em,
  .pursuit-state-SUPERSEDED em,
  .pursuit-state-WORK_CONDITION_CLOSED em,
  .pursuit-state-OFFLINE_CLOSED em {
    color: #b9c8cf;
  }

  .pursuit-notice-detail {
    width: 100%;
    min-height: 34px;
    margin-top: 10px;
    padding: 0 12px;
    box-sizing: border-box;
    border: 1px solid #f6c343;
    border-radius: 5px;
    color: #211a05;
    background: #f6c343;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    transition: background .2s ease, border-color .2s ease, box-shadow .2s ease;
  }

  .pursuit-notice-detail:hover {
    border-color: #ffe18a;
    background: #ffda63;
    box-shadow: 0 0 12px rgba(246, 195, 67, .35);
  }

  .notice-title {
    font-size: 17px;
    color: #ed4014;
    font-weight: bold;
  }

  .notice-img {
    border-radius: 4px;
    width: 120px;
    height: 120px;
    display: block;
  }

  .notice-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .mute-settings {
    margin-bottom: 4px;
  }

  .time-input-wrapper {
    position: relative;  /* 添加相对定位 */
    display: flex;
    align-items: center;
    gap: 6px;
    background: #f8f8f9;
    padding: 4px 6px;
    border-radius: 4px;
  }

  .error-tip {
    position: absolute;
    top: -20px;  /* 位于输入框上方 */
    left: 0;
    right: 0;
    text-align: center;
    color: #ed4014;
    font-size: 12px;
    min-height: 16px;
    padding: 0 4px;
  }

  /* 当有错误提示时，增加上边距 */
  .time-input-wrapper:has(.error-tip:not(:empty)) {
    margin-top: 20px;
  }

  .mute-label {
    color: #e46f2b;
    font-size: 13px;
    white-space: nowrap;
    font-weight: bold;
  }

  .time-select {
    height: 24px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    outline: none;
    padding: 0 4px;
    background: white;
    cursor: pointer;
    transition: all 0.3s;
    min-width: 65px;
  }

  .time-select:focus {
    border-color: #2d8cf0;
  }

  .custom-time-input {
    width: 60px;
    height: 24px;
    padding: 0 4px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    outline: none;
    transition: all 0.3s;
    text-align: center;
  }

  .custom-time-input:focus {
    border-color: #2d8cf0;
  }

  .mute-confirm {
    height: 24px;
    padding: 0 8px;
    font-size: 12px;
    color: #fff;
    background: #2d8cf0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
  }

  .action-buttons {
    display: flex;
    gap: 4px;
    margin-top: 4px;
  }

  .btn {
    flex: 1;
    padding: 3px 8px;
    font-size: 12px;
    border: none;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s;
    margin: 0;
  }

  .btn.primary {
    background: #2db7f5;
  }

  .btn.warning {
    background: #ff9900;
  }

  .btn.danger {
    background: #ed4014;
  }

  .btn:hover {
    opacity: 0.85;
  }

  /* 三维看板按钮样式 */
  .three-d-dashboard-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    height: 63px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: linear-gradient(135deg, rgba(45, 140, 240, 0.1), rgba(45, 140, 240, 0.15));
    border: 1px solid rgba(45, 140, 240, 0.3);
    font-weight: 500;
    white-space: nowrap;
    box-shadow: 0 2px 4px rgba(45, 140, 240, 0.1);
  }

  .three-d-dashboard-btn .btn-text {
    color: #2d8cf0;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  .three-d-dashboard-btn:hover {
    background: linear-gradient(135deg, rgba(45, 140, 240, 0.2), rgba(45, 140, 240, 0.25));
    border-color: rgba(45, 140, 240, 0.5);
    box-shadow: 0 4px 12px rgba(45, 140, 240, 0.25);
  }

  .three-d-dashboard-btn:hover .btn-text {
    color: #1c7cd6;
  }

  .three-d-dashboard-btn:active {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(45, 140, 240, 0.2);
  }

  /* 紧急通知动作标识：与历史表格保持同一套语义 */
  .error-notification .description .emergency-action-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 24px;
    margin-left: 4px;
    padding: 2px 10px 2px 5px;
    border: 1px solid transparent;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0.2px;
    vertical-align: middle;
    white-space: nowrap;
  }

  .error-notification .description .emergency-action-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 800;
    line-height: 1;
  }

  .error-notification .description .emergency-action-stop {
    color: #ff8b8b;
    background: linear-gradient(135deg, rgba(255, 64, 64, 0.24), rgba(183, 28, 28, 0.16));
    border-color: rgba(255, 99, 99, 0.72);
    box-shadow: 0 0 12px rgba(255, 64, 64, 0.24);
  }

  .error-notification .description .emergency-action-stop .emergency-action-icon {
    color: #fff;
    background: #ef5350;
    box-shadow: 0 0 8px rgba(255, 82, 82, 0.75);
  }

  .error-notification .description .emergency-action-recover {
    color: #76f2b2;
    background: linear-gradient(135deg, rgba(0, 200, 130, 0.22), rgba(0, 120, 90, 0.14));
    border-color: rgba(57, 220, 145, 0.7);
    box-shadow: 0 0 12px rgba(0, 220, 140, 0.2);
  }

  .error-notification .description .emergency-action-recover .emergency-action-icon {
    color: #003d2c;
    background: #5af0a5;
    box-shadow: 0 0 8px rgba(90, 240, 165, 0.65);
  }

  .error-notification .description .emergency-action-unknown {
    color: #8edcff;
    background: rgba(0, 180, 255, 0.14);
    border-color: rgba(0, 200, 255, 0.5);
  }

  .error-notification .description .emergency-action-unknown .emergency-action-icon {
    color: #002d40;
    background: #72ddff;
  }

  .error-notification .description .emergency-reason-text {
    color: #9bdcff;
    font-weight: 500;
    letter-spacing: 0.15px;
    text-shadow: 0 0 8px rgba(95, 207, 255, 0.28);
  }

  /* 紧急通知详情：将标题、标签和值整理成信息卡片 */
  .error-notification.notification-emergency {
    width: 440px;
    max-width: calc(100vw - 32px);
    box-sizing: border-box;
    padding: 18px 20px 20px;
  }

  .error-notification.notification-emergency .notification-content {
    gap: 14px;
    margin-bottom: 4px;
  }

  .error-notification.notification-emergency .message-wrapper {
    padding-right: 22px;
  }

  .error-notification.notification-emergency .title {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    color: #f3fcff;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 1px;
    text-shadow: 0 0 12px rgba(181, 239, 255, 0.42);
  }

  .error-notification.notification-emergency .title::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 19px;
    border-radius: 3px;
    background: linear-gradient(180deg, #ff7676, #ffad66);
    box-shadow: 0 0 10px rgba(255, 99, 99, 0.72);
  }

  .error-notification.notification-emergency .title::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 1px;
    background: linear-gradient(90deg, rgba(255, 103, 103, 0.8), rgba(88, 214, 255, 0.45), transparent);
  }

  .error-notification.notification-emergency .description {
    display: flex;
    flex-direction: column;
    gap: 5px;
    color: #e9f9ff;
    line-height: 1.35;
  }

  .error-notification.notification-emergency .emergency-detail-row {
    display: flex;
    align-items: center;
    min-height: 27px;
    padding: 3px 8px;
    border: 1px solid rgba(80, 193, 231, 0.14);
    border-radius: 6px;
    background: linear-gradient(100deg, rgba(18, 80, 112, 0.3), rgba(3, 35, 61, 0.22));
    box-shadow: inset 0 1px 0 rgba(183, 239, 255, 0.04);
  }

  .error-notification.notification-emergency .emergency-detail-row:nth-child(even) {
    background: linear-gradient(100deg, rgba(21, 96, 126, 0.24), rgba(3, 35, 61, 0.16));
  }

  .error-notification.notification-emergency .emergency-detail-label {
    position: relative;
    flex: 0 0 76px;
    padding-left: 9px;
    color: rgba(186, 225, 237, 0.72);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.35px;
    white-space: nowrap;
  }

  .error-notification.notification-emergency .emergency-detail-label::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 3px;
    height: 12px;
    border-radius: 2px;
    background: #4ec9ec;
    box-shadow: 0 0 7px rgba(78, 201, 236, 0.72);
    transform: translateY(-50%);
  }

  .error-notification.notification-emergency .emergency-detail-value {
    min-width: 0;
    overflow: hidden;
    color: #eefaff;
    font-size: 13px;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .error-notification.notification-emergency .emergency-value-code {
    color: #a8e8ff;
    font-family: Consolas, 'Courier New', monospace;
    letter-spacing: 0.4px;
  }

  .error-notification.notification-emergency .emergency-value-time {
    color: #c4e8f2;
    font-variant-numeric: tabular-nums;
  }

  .error-notification.notification-emergency .emergency-row-robot {
    border-color: rgba(78, 201, 236, 0.34);
    background: linear-gradient(100deg, rgba(19, 101, 139, 0.34), rgba(3, 39, 65, 0.22));
  }

  .error-notification.notification-emergency .emergency-row-robot .emergency-detail-label {
    color: #9bdff3;
  }

  .error-notification.notification-emergency .emergency-row-robot .emergency-detail-label::before {
    background: #4ec9ec;
    box-shadow: 0 0 7px rgba(78, 201, 236, 0.76);
  }

  .error-notification.notification-emergency .emergency-row-robot .emergency-value-robot {
    color: #d2f5ff;
  }

  .error-notification.notification-emergency .emergency-row-code {
    border-color: rgba(171, 139, 255, 0.34);
    background: linear-gradient(100deg, rgba(73, 52, 131, 0.3), rgba(25, 28, 71, 0.24));
  }

  .error-notification.notification-emergency .emergency-row-code .emergency-detail-label {
    color: #c7b7ff;
  }

  .error-notification.notification-emergency .emergency-row-code .emergency-detail-label::before {
    background: #ab8bff;
    box-shadow: 0 0 7px rgba(171, 139, 255, 0.76);
  }

  .error-notification.notification-emergency .emergency-row-code .emergency-value-code {
    color: #e0d6ff;
  }

  .error-notification.notification-emergency .emergency-row-action {
    border-color: rgba(255, 112, 112, 0.34);
    background: linear-gradient(100deg, rgba(123, 48, 62, 0.28), rgba(54, 28, 49, 0.22));
  }

  .error-notification.notification-emergency .emergency-row-action .emergency-detail-label {
    color: #ffb0a8;
  }

  .error-notification.notification-emergency .emergency-row-action .emergency-detail-label::before {
    background: #ff7373;
    box-shadow: 0 0 7px rgba(255, 115, 115, 0.76);
  }

  .error-notification.notification-emergency .emergency-row-alert {
    border-color: rgba(255, 112, 112, 0.34);
    background: linear-gradient(100deg, rgba(123, 48, 62, 0.28), rgba(54, 28, 49, 0.22));
  }

  .error-notification.notification-emergency .emergency-row-alert .emergency-detail-label {
    color: #ffb0a8;
  }

  .error-notification.notification-emergency .emergency-row-alert .emergency-detail-label::before {
    background: #ff7373;
    box-shadow: 0 0 7px rgba(255, 115, 115, 0.76);
  }

  .error-notification.notification-emergency .emergency-row-reason {
    border-color: rgba(255, 193, 93, 0.36);
    background: linear-gradient(100deg, rgba(123, 87, 34, 0.28), rgba(54, 39, 27, 0.22));
  }

  .error-notification.notification-emergency .emergency-row-reason .emergency-detail-label {
    color: #ffd58b;
  }

  .error-notification.notification-emergency .emergency-row-reason .emergency-detail-label::before {
    background: #ffc15d;
    box-shadow: 0 0 7px rgba(255, 193, 93, 0.76);
  }

  .error-notification.notification-emergency .emergency-row-reason .emergency-reason-text {
    color: #ffe0a4;
    text-shadow: 0 0 8px rgba(255, 193, 93, 0.28);
  }

  .error-notification.notification-emergency .emergency-row-time {
    border-color: rgba(105, 218, 188, 0.32);
    background: linear-gradient(100deg, rgba(24, 104, 96, 0.28), rgba(19, 55, 65, 0.22));
  }

  .error-notification.notification-emergency .emergency-row-time .emergency-detail-label {
    color: #9ee3d2;
  }

  .error-notification.notification-emergency .emergency-row-time .emergency-detail-label::before {
    background: #69dabc;
    box-shadow: 0 0 7px rgba(105, 218, 188, 0.76);
  }

  .error-notification.notification-emergency .emergency-row-time .emergency-value-time {
    color: #c6f0e5;
  }

  .error-notification.notification-emergency .emergency-detail-empty {
    color: rgba(210, 239, 247, 0.42);
  }
</style>
